import { Badge } from '@repo/ui/components/Badge';
import { H3 } from '@repo/ui/components/Typography';
import { ProfileImage } from '@repo/ui/deprecated/ProfileImage';
import { themeStyle, useNewThemeActive } from '@repo/ui/theming';

import { useUserStore, userStoreSelector } from '../../../../stores/userStore';
import Tag from '../../../Tag/Tag';
import { specialTheme } from '../../../Tag/theme';
import { isPlanObject } from '../../utils';

import PlanCard from './PlanCard';
import { TeamWrapper, PlanBox, PlanInfoTitle, TeamHeader } from './styles';
import { PlansOverviewProps } from './types';

const PlansOverview: React.FC<PlansOverviewProps> = ({
  currentSubscription,
  changeSubscriptionPreview,
}) => {
  const team = useUserStore(userStoreSelector.user)?.team;
  const { preview: previewSubscription } = changeSubscriptionPreview;

  const isNewThemeActive = useNewThemeActive();

  // Only show this component to teams that are on a paid plan
  if (!currentSubscription?.plan || !team?.plan) {
    return null;
  }

  return (
    <TeamWrapper>
      <TeamHeader>
        <ProfileImage
          profile={{
            name: team.name,
            profileImage: team.profileImage,
            isTeam: true,
          }}
          size="32px"
        />
        <H3 as="div">{team.name}</H3>
        {isNewThemeActive ? (
          <Badge text={team.plan} variant="blue" />
        ) : (
          <Tag theme={specialTheme}>{team.plan}</Tag>
        )}
      </TeamHeader>

      <PlanBox theme={{ boxShadow: themeStyle.varShadowSoft }}>
        <PlanInfoTitle>New Plan</PlanInfoTitle>
        {previewSubscription ? (
          <PlanCard plan={previewSubscription.plan} />
        ) : currentSubscription.plan &&
          isPlanObject(currentSubscription.plan) ? (
          <PlanCard plan={currentSubscription.plan} />
        ) : null}
      </PlanBox>

      <PlanBox
        theme={{
          boxShadow: themeStyle.varShadowSoft,
          backgroundColor: themeStyle.varInkSuperLight,
        }}
      >
        <PlanInfoTitle color={themeStyle.varInkMedium}>
          Current Plan
        </PlanInfoTitle>
        {currentSubscription.plan && isPlanObject(currentSubscription.plan) && (
          <PlanCard disabled plan={currentSubscription.plan} />
        )}
      </PlanBox>
    </TeamWrapper>
  );
};

export default PlansOverview;
